import { use } from 'react';
import {
  LocalizedPageUrlContext,
  LocalizedPageUrlContextDispatchContext,
} from './LocalizedPageUrlProvider';

export const useLocalizedPageUrl = () => use(LocalizedPageUrlContext);

export const useLocalizedPageUrlDispatch = () => use(LocalizedPageUrlContextDispatchContext);
